import { Box, styled } from '@mui/material'

const IconContainer = styled(Box)({
    minWidth: '40px',
    width: '40px',
    height: '40px',

    borderRadius: '50%',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
})

export default IconContainer
